import { GetServerSidePropsContext } from "next";
import api from "./api";
import type { Article } from "./article-model";

export type { Article };

export default function loadAllArticles(
  companySlug: string,
  context?: GetServerSidePropsContext,
  appId?: string
) {
  return api<Article[] | undefined>({
    path: `/helpcenter-public/experimental/${companySlug}/navigation-tree`,
    context,
    appId,
  }).then((articles) => articles?.sort((a, b) => a.order - b.order));
}
